// extracted by mini-css-extract-plugin
export default {"root":"UnderwritingAnswerButtons_root__9kFXe"};